import gql from "graphql-tag";

export const uploadForm = gql`
  mutation uploadForm($input: uploadFormInput!) {
    uploadForm(input: $input) {
      success
    }
  }
`;

export const login = gql`
    mutation login($code: String!, $state: String! ){
        login(code: $code, state: $state){
            success,
            errors,
            access_token,
            token_type,
            name,
            state
        }
    }
`;
